module.exports = __webpack_public_path__ + "img/BOWTIE 2 PURPLE.612b0e4.svg";